<template>
  <span
    v-if="label"
    class="hub-new-badge"
    >{{ label }}</span
  >
</template>

<script>
export default {
  name: "HubNewBadge",
  props: {
    label: {
      type: String,
      default: "NOVO"
    }
  }
};
</script>

<style scoped>
.hub-new-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: var(--colors-light-support-news);
  color: #fff;
  border-radius: 16px;
  padding: 2px 8px;
  font-size: 10px;
  line-height: 14px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  white-space: nowrap;
}
</style>
